export const lifecycleLabels = {
    new: 'Neu',
    contacted: 'Kontaktiert',
    call_booked: 'Call gebucht',
    prospect: 'Interessent',
    customer: 'Kunde',
    existing_customer: 'Bestandskunde',
    follow_up: 'Follow Up',
    no_show: 'No Show',
    not_reached: 'Nicht erreicht',
    no_interest: 'Kein Interesse',
    disqualified: 'Disqualifiziert',
};
export const terminalLifecycleKeys = ['no_interest', 'disqualified'];
export const mainPathLifecycleKeys = [
    'new',
    'contacted',
    'call_booked',
    'prospect',
    'customer',
    'existing_customer',
];
export const contactLifecycleMachine = {
    name: 'contact_lifecycle',
    states: [
        'new',
        'contacted',
        'call_booked',
        'prospect',
        'customer',
        'existing_customer',
        'follow_up',
        'no_show',
        'not_reached',
        'no_interest',
        'disqualified',
    ],
    labels: lifecycleLabels,
    // The `from` lists bind the automatic transitions only (bookings, calls, deals never move a contact
    // backwards). By hand every stage can be set from every other stage (Paul 29.10.2026, D-333);
    // `new` exists only as a manual target. „Interessent" (a deal exists) and „Kunde" (a deal is notarized)
    // follow the owner decision of 02.11.2026 (D-430): „nach dem Notar ist einer Kunde, davor Interessent".
    transitions: [
        { name: 'new', label: 'Neu', from: [], to: 'new' },
        { name: 'contacted', label: 'Kontaktiert', from: ['new'], to: 'contacted', automatic: true },
        {
            name: 'call_booked',
            label: 'Call gebucht',
            from: ['new', 'contacted', 'follow_up', 'no_show', 'not_reached'],
            to: 'call_booked',
            automatic: true,
        },
        {
            name: 'prospect',
            label: 'Interessent',
            from: ['new', 'contacted', 'call_booked', 'follow_up', 'no_show', 'not_reached'],
            to: 'prospect',
            automatic: true,
        },
        {
            name: 'customer',
            label: 'Kunde',
            from: ['new', 'contacted', 'call_booked', 'prospect', 'follow_up', 'no_show', 'not_reached'],
            to: 'customer',
            automatic: true,
        },
        {
            name: 'existing_customer',
            label: 'Bestandskunde',
            from: ['customer'],
            to: 'existing_customer',
            automatic: true,
        },
        {
            name: 'follow_up',
            label: 'Follow Up',
            from: ['new', 'contacted', 'call_booked', 'prospect', 'customer', 'no_show', 'not_reached'],
            to: 'follow_up',
            reasonRequired: true,
            nextStepRequired: true,
        },
        {
            name: 'not_reached',
            label: 'Nicht erreicht',
            from: ['new', 'contacted', 'call_booked', 'follow_up', 'no_show'],
            to: 'not_reached',
            reasonRequired: true,
            nextStepRequired: true,
        },
        {
            name: 'no_show',
            label: 'No Show',
            from: ['call_booked', 'prospect', 'customer', 'follow_up', 'not_reached'],
            to: 'no_show',
            reasonRequired: true,
        },
        {
            name: 'no_interest',
            label: 'Kein Interesse',
            from: [
                'new',
                'contacted',
                'call_booked',
                'prospect',
                'customer',
                'follow_up',
                'no_show',
                'not_reached',
            ],
            to: 'no_interest',
            reasonRequired: true,
        },
        {
            name: 'disqualified',
            label: 'Disqualifiziert',
            from: [
                'new',
                'contacted',
                'call_booked',
                'prospect',
                'customer',
                'follow_up',
                'no_show',
                'not_reached',
            ],
            to: 'disqualified',
            reasonRequired: true,
        },
    ],
};
//# sourceMappingURL=contact-lifecycle.js.map